const messagesMixins = {
    props: {
        message: {
            type: Object,
            required: true,
        },
    },
};

export default messagesMixins;
